/** Expected unsupported or incomplete artwork; programming errors remain distinguishable. */
export default class PrintableContentError extends Error {
  readonly incomplete: boolean;

  constructor(message: string, incomplete = false) {
    super(message);
    this.incomplete = incomplete;
  }
}
